import React from 'react';
import Layout from './components/Layout';
import Home from './components/pages/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './main.css';
import AddTask from './components/pages/AddTask';
import EditTask from './components/pages/EditTask';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/add-task' element={<AddTask />} />
          <Route path='/edit-task/:taskId' element={<EditTask />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
